import {ResourceParams, resources} from "../../../../models/resource/resources";
import {PossibleAudienceAge, PossibleGeoName} from "../../../../types/records-table.types";

export const audienceResourceType: ResourceParams = resources['audiences'];

export const titlesForAudienceAge: { [key in PossibleAudienceAge]: string } = {
  '1317': '13-17',
  '1824': '18-24',
  '2534': '25-34',
  '3544': '35-44',
  '4554': '45-54',
  '5564': '55-64',
  '65': '65+',
}

export const titlesForAudienceGeo: { [key in PossibleGeoName]: string } = {
  ru: 'Россия',
  br: 'Беларусь',
  kz: 'Казахстан',
  ua: 'Украина',
  other: 'Другие',
}
